var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466.667 0C448.26 0 433.333 14.9062 433.333 33.3333V110.51C391.771 52.625 324.375 16.6667 250 16.6667C151.562 16.6667 65.1979 79.5208 34.9792 173.125C29.3146 190.635 38.9344 209.458 56.4479 215.083C74.0417 220.812 92.7812 211.112 98.4271 193.635C119.687 127.604 180.625 83.3333 250 83.3333C302.604 83.3333 350.271 108.906 379.583 150H333.333C314.927 150 300 164.906 300 183.333C300 201.76 314.927 216.667 333.333 216.667H466.667C485.073 216.667 500 201.76 500 183.333V33.3333C500 14.9062 485.104 0 466.667 0ZM443.542 285C425.917 279.335 407.208 288.971 401.562 306.448C380.312 372.396 319.375 416.667 250 416.667C197.396 416.667 149.74 391.094 120.417 350H166.667C185.073 350 200 335.094 200 316.667C200 298.24 185.073 283.333 166.667 283.333H33.3333C14.9271 283.333 0 298.24 0 316.667V466.667C0 485.094 14.9271 500 33.3333 500C51.7396 500 66.6667 485.094 66.6667 466.667V389.49C108.229 447.396 175.625 483.333 249.062 483.333C347.448 483.333 433.854 420.479 464.062 326.875C470.729 309.375 461.042 289.688 443.542 285Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.2592e9aa07f6c5eb38bbc3eb5b4c3b54.svg";
export { ForwardRef as ReactComponent };